<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">
                        <!-- designation -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Designation :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="designationId" name="designationId"
                                    label="text"
                                    @input="changedValueDesignation"
                                    :options="designationArr" :clearable=false placeholder="Select Designation">
                                </v-select>
                                <div class="help is-danger">{{designationError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Department -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Department :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="departmentId" name="departmentId"
                                    label="text"
                                    @input="changedValueDepartment"
                                    :options="departmentArr" :clearable=false placeholder="Select Department">
                                </v-select>
                                <div class="help is-danger">{{departmentIdError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Empolyee Number -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Employee First Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="employeeFirstNameError = ''" maxlength="190" class="form-control" v-model="employeeFirstName" id="employeeFirstName" placeholder="Enter Employee First Name" name="employeeFirstName">
                                <div class="help is-danger">{{employeeFirstNameError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        
                        <!-- Empolyee Last Name -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Employee Last Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="employeeLastNameError = ''" maxlength="190" class="form-control" v-model="employeeLastName" id="employeeLastName" placeholder="Enter Employee Last Name" name="employeeLastName">
                                <div class="help is-danger">{{employeeLastNameError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        
                        <!-- Location -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Location :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="location" name="location"
                                    label="name" placeholder="Select Location"
                                    @input="location_error = ''"
                                    :options="location_arr" :clearable=false>
                                </v-select>
                                <div class="help is-danger">{{location_error}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Requestor Name -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Requestor Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <!-- <input type="text" maxlength="190" class="form-control" v-model="requestorName" id="requestorName" placeholder="Enter Requestor Name" name="requestorName"> -->
                                <span class="form-control">{{requestorName}}</span>
                                <!-- <div class="help is-danger">{{requestorNameError}}</div> -->
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- New Hire -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">New Hire :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="newHire" name="newHire"
                                    label="text"
                                    @input="changedValue"
                                    :options="newHireArr" :clearable=false placeholder="Select New Hire">
                                </v-select>
                                <div class="help is-danger">{{newHireError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- New Order -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">New Order :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="newOrder" name="newOrder"
                                    label="text"
                                    @input="changedValue"
                                    :options="newOrderArr" :clearable=false placeholder="Select New Order">
                                </v-select>
                                <div class="help is-danger">{{newOrderError}}</div>
                                <!-- <span class="form-control">{{newOrder.text}}</span> -->
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Re Order -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Replacement Uniform :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="reOrder" name="reOrder"
                                    label="text"
                                    @input="changedValue"
                                    :options="reOrderArr" :clearable=false placeholder="Select Replacement Uniform">
                                </v-select>
                                <div class="help is-danger">{{reOrderError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- wear -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Wear :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="wearId" name="wearId"
                                    label="text"
                                    @input="changedValueWear"
                                    :options="wearArr" :clearable=false placeholder="Select Wear">
                                </v-select>
                                <div class="help is-danger">{{wearError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Size -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Size(s) :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <textarea type="text" @input="textError = ''" class="form-control" v-model="text" id="text" placeholder="Enter Size(s)" name="text"></textarea>
                                <div class="help is-danger">{{textError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <template v-if="!categoryShow">
                            <!-- Quantity -->
                            <div class="col-4 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Total Item Quantity :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="quantityError = ''" maxlength="190" class="form-control" v-model="quantity" id="quantity" placeholder="Enter Total Item Quantity" name="quantity">
                                    <div class="help is-danger">{{quantityError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <!-- Total Shirt Quantity -->
                            <div class="col-4 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Total Shirt Quantity :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="shirtQuantityError = ''" maxlength="190" class="form-control" v-model="shirtQuantity" id="shirtQuantity" placeholder="Enter Total Shirt Quantity" name="quantity">
                                    <div class="help is-danger">{{shirtQuantityError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <!-- Total Pant Quantity -->
                            <div class="col-4 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Total Pant Quantity :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="pantQuantityError = ''" maxlength="190" class="form-control" v-model="pantQuantity" id="pantQuantity" placeholder="Enter Total Pant Quantity" name="quantity">
                                    <div class="help is-danger">{{pantQuantityError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                        </template>
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Note/Comment :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <textarea type="text" @input="commentError = ''" class="form-control" v-model="comment" id="comment" placeholder="Note/Comment" name="comment"></textarea>
                                <div class="help is-danger">{{commentError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <template v-if="categoryShow">
                            <div class="col-4 forms-block">
                                &nbsp;
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-4 forms-block">
                                &nbsp;
                            </div>
                            <div class="col-4 forms-block">
                                &nbsp;
                            </div>
                        </template>
                        <div class="clearfix"></div>
                        <div class="mr-17 pb-12 float-l">
                            <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                            <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addTechnicianUniform('save')"><span id="createAttachment">Save</span></button>
                        </div>

                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdateTechnicianUniform',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Uniform Request',
                edit_id: 0,
                designationId: "",
                designationError: "",
                designationArr: [ 
                    {
                        text: 'Central Ops',
                        value: 'Central Ops',
                    },
                    {
                        text: 'Driver/Porter',
                        value: 'Driver/Porter',
                    },
                    {
                        text: 'Manager',
                        value: 'manager',
                    },
                    {
                        text: 'Technician',
                        value: 'technician',
                    },
                ],
                departmentArr: [ 
                    {
                        text: 'Body Shop',
                        value: 'Body Shop',
                    },
                    {
                        text: 'Service',
                        value: 'Service',
                    },
                ],
                departmentId: "",
                departmentIdError: "",
                employeeFirstName: "",
                employeeFirstNameError: "",
                employeeLastName: "",
                employeeLastNameError: "",
                location: "",
                location_arr: [],
                location_error: "",
                requestorName: "",
                requestorNameError: "",
                newHireArr: [
                    {
                        text: 'No',
                        value: 'no',
                    },
                    {
                        text: 'Yes',
                        value: 'yes',
                    },
                ],
                newHire: {text: 'No', value: 'no'},
                newHireError: "",
                newOrderArr: [
                    {
                        text: 'No',
                        value: 'no',
                    },
                    {
                        text: 'Yes',
                        value: 'yes',
                    },
                ],
                newOrder: {text: 'No', value: 'no'},
                newOrderError: "",
                reOrderArr: [
                    {
                        text: 'No',
                        value: 'no',
                    },
                    {
                        text: 'Yes',
                        value: 'yes',
                    },
                ],
                reOrder: {text: 'No', value: 'no'},
                reOrderError: "",
                wearId: "",
                wearError: "",
                wearArr: [],
                wearShirtPantArr: [ 
                    {
                        text: 'Pant',
                        value: 'pant',
                    },
                    {
                        text: 'Shirt',
                        value: 'shirt',
                    },
                    {
                        text: 'Shirt & Pant',
                        value: 'Shirt & Pant',
                    },
                ],
                wearPoloArr: [ 
                    {
                        text: 'Polo',
                        value: 'polo',
                    },
                ],
                text: "",
                textError: "",
                quantity: "",
                quantityError: "",
                shirtQuantity: "",
                shirtQuantityError: "",
                pantQuantity: "",
                pantQuantityError: "",
                comment: "",
                commentError: "",

                managerEmail: "",
                loginUserRoleId: 1,
                bodyShopLocationArr: [],
                serviceLocationArr: [],
                categoryShow: false,
            }
        },
        watch: {
            location: function(location) {
                self.managerEmail = "";
                if (location != null || location.id) {
                    for(var index = 0;index<self.location_arr.length;index++) {
                        var obj = self.location_arr[index];
                        if(obj['id'] == location.id) {
                            self.managerEmail = obj['manager_email'];
                        }
                    }
                }
            },
            newHire: function(newHire) {
                self.newOrder = newHire;
            },
            wearId: function(wearId) {
                self.categoryShow = false;
                self.shirtQuantity = '';
                self.pantQuantity = '';
                if (wearId != null || wearId.value) {
                    if (self.designationId != null || self.designationId.value) {
                        if(self.designationId.value == 'technician' && wearId.value == 'Shirt & Pant') {
                            self.quantity = "";
                            self.categoryShow = true;
                        }
                    }
                }
            },
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("TechnicianUniForm");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
                self.requestorName = userJson['first_name'] + " " + userJson['last_name'];
            }
            self.loadLocation();
            self.loadBodyShopLocation();
        },
        methods: {
            buttonBack() {
                self.$router.push('/technician/uniform/list');
            },
            changedValueDesignation: function(params) {
                self.designationError = "";
                self.wearArr = [];
                self.wearId = '';
                if (self.designationId != 'undefined' && self.designationId.value) {
                    self.wearArr = self.wearPoloArr;
                    if(self.designationId.value == 'technician' || self.designationId.value == 'Driver/Porter') {
                        self.wearArr = self.wearShirtPantArr;
                    }
                }
            },
            changedValueWear: function(params) {
                self.wearError = "";
            },
            changedValueDepartment: function(department) {
                self.departmentIdError = "";
                self.location_arr = [];
                self.location = "";
                if (department != 'undefined' && department.value) {
                    self.location_arr = self.serviceLocationArr;
                    if(department.value == 'Body Shop') {
                        self.location_arr = self.bodyShopLocationArr;
                    }
                }
            },
            changedValue: function () {
            },
            loadBodyShopLocation: function() {
                var config = {
                    params: {
                        // slug: "vvg-au",
                        // department_id: 8
                    }
                };
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                    .then(function (response) {
                        self.bodyShopLocationArr = response.data.locations;
                        if(self.bodyShopLocationArr && self.bodyShopLocationArr.length > 0) {
                            /* for(var index = 0; index < self.bodyShopLocationArr.length; index++) {
                                var objLocation = self.bodyShopLocationArr[index];
                                if(objLocation['name'] == 'Hope Mills Bodyshop, NC' || objLocation['id'] == 76) {
                                    self.bodyShopLocationArr.splice(index, 1);
                                }
                            } */
                            self.bodyShopLocationArr = self.bodyShopLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                        }
                        // console.log(JSON.stringify(self.bodyShopLocationArr));
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            loadLocation: function() {
                var config = {
                    params: {
                        // slug: "vvg-au",
                        // department_id: 2
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                        .then(function (response) {
                            // self.location_arr = response.data.locations;
                            self.serviceLocationArr = response.data.locations;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            checkForm: function () {
                var checked = true;
                self.location_error = "";
                self.designationError = "";
                self.departmentIdError = "";
                self.employeeFirstNameError = "";
                self.employeeLastNameError = "";
                self.requestorNameError = "";
                self.wearError = "";
                self.textError = "";
                self.quantityError = "";
                self.shirtQuantityError = "";
                self.pantQuantityError = "";
                self.commentError = "";

                if (self.designationId == null || !self.designationId.value) {
                    self.designationError = "Select designation";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.departmentId == null || !self.departmentId.value) {
                    self.departmentIdError = "Select Department";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.location == null || !self.location.id) {
                    self.location_error = "select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.employeeFirstName) {
                    self.employeeFirstNameError = "Please enter employee first name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.employeeLastName) {
                    self.employeeLastNameError = "Please enter employee last name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.requestorName) {
                    self.requestorNameError = "Please enter requestor name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.wearId == null || !self.wearId.value) {
                    self.wearError = "Select wear";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.text) {
                    self.textError = "Please enter Size(s)";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.categoryShow) {
                    if (!self.quantity) {
                        self.quantityError = "Please enter Total Item Quantity";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.quantity && !self.numberFormateValidation(self.quantity)) {
                        self.quantityError = "Please enter numeric value";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.quantity && self.numberFormateValidation(self.quantity) && self.quantity > 1000) {
                        self.quantityError = "Max Quantity is 1000";
                        if (checked) {
                            checked = false;
                        }
                    }
                } else {
                    if (!self.shirtQuantity) {
                        self.shirtQuantityError = "Please enter Total Shirt Quantity";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.shirtQuantity && !self.numberFormateValidation(self.shirtQuantity)) {
                        self.shirtQuantityError = "Please enter numeric value";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.shirtQuantity && self.numberFormateValidation(self.shirtQuantity) && self.shirtQuantity > 1000) {
                        self.shirtQuantityError = "Max Shirt Quantity is 1000";
                        if (checked) {
                            checked = false;
                        }
                    }

                    if (!self.pantQuantity) {
                        self.pantQuantityError = "Please enter Total Pant Quantity";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.pantQuantity && !self.numberFormateValidation(self.pantQuantity)) {
                        self.pantQuantityError = "Please enter numeric value";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.pantQuantity && self.numberFormateValidation(self.pantQuantity) && self.pantQuantity > 1000) {
                        self.pantQuantityError = "Max Pant Quantity is 1000";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (!self.comment) {
                    self.commentError = "Please enter Note/Comment";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addTechnicianUniform(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        };
                        var fields = {
                            id: self.edit_id,
                            manager_email: self.managerEmail,
                            designation_id: self.designationId.value,
                            departmentName: self.departmentId.value,
                            location_id: self.location.id,
                            location: self.location.name,
                            empolyee_first_name: self.employeeFirstName,
                            empolyee_last_name: self.employeeLastName,
                            new_hire: self.newHire.value,
                            new_order: self.newOrder.value,
                            re_order: self.reOrder.value,
                            requestor_name: self.requestorName,
                            wear_id: self.wearId.value,
                            text: self.text,
                            quantity: self.quantity,
                            shirt_quantity: self.shirtQuantity,
                            pant_quantity: self.pantQuantity,
                            comment: self.comment,
                        };
                        self.showLoader();
                        HTTP.post("/technician/uniform/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if(self.loginUserRoleId == 1 || self.loginUserRoleId == 2) {
                                        self.buttonBack();
                                    } else {
                                        self.edit_id = 0;
                                        self.designationId = "";
                                        self.managerEmail = '';
                                        self.departmentId = '';
                                        self.location = '';
                                        self.employeeFirstName = '';
                                        self.employeeLastName = '';
                                        // self.requestorName = '';
                                        self.wearId = "";
                                        self.text = "";
                                        self.quantity = '';
                                        self.shirtQuantity = '';
                                        self.pantQuantity = '';
                                        self.newHire = {text: 'No', value: 'no'};
                                        self.newOrder = {text: 'No', value: 'no'};
                                        self.reOrder = {text: 'No', value: 'no'};
                                        self.categoryShow = false;
                                        self.comment = "";
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
        }
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Forms/TechnicianUniformMaster/AddUpdateTechnicianUniform.vue